import { useTheme } from 'next-themes';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Moon, Sun, Monitor } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export function ThemeSettings() {
  const { theme, setTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Sun className="h-5 w-5" />
          Tema de la Aplicación
        </CardTitle>
        <CardDescription>
          Elige entre modo claro, oscuro o automático del sistema
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <Label>Modo de Visualización</Label>
          <ToggleGroup 
            type="single" 
            value={theme} 
            onValueChange={(value) => value && setTheme(value)}
            className="justify-start"
          >
            <ToggleGroupItem value="light" aria-label="Modo claro" className="flex items-center gap-2 px-4">
              <Sun className="h-4 w-4" />
              <span>Claro</span>
            </ToggleGroupItem>
            <ToggleGroupItem value="dark" aria-label="Modo oscuro" className="flex items-center gap-2 px-4">
              <Moon className="h-4 w-4" />
              <span>Oscuro</span>
            </ToggleGroupItem>
            <ToggleGroupItem value="system" aria-label="Sistema" className="flex items-center gap-2 px-4">
              <Monitor className="h-4 w-4" />
              <span>Sistema</span>
            </ToggleGroupItem>
          </ToggleGroup>
        </div>
        
        <p className="text-sm text-muted-foreground">
          El cambio se aplica automáticamente sin necesidad de guardar.
        </p>
      </CardContent>
    </Card>
  );
}
